<template>
  <div class="button-container" :class="`button-container--gutter-${gutterSize}`">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'ButtonContainer',
  props: {
    gutterSize: {
      type: String,
      required: false,
      default: 'small',
      validation: (value) => ['small', 'medium', 'large'].includes(value),
    },
  },
}
</script>
